import BackendApi from './BackendApi'



export default class MessageChat {
    static TYPE_START_MESSAGE = "start-message";
    static TYPE_MESSAGE = "message";
    static TYPE_END_MESSAGE = "end-message"; 
    static TYPE_READ_MESSAGE = "read-message";
    static TYPE_INCARICO_MESSAGE = "incarico-message"
    static TYPE_RILASCIA_MESSAGE = "rilascia-message"
    static TYPE_TYPING_MESSAGE = "typing-message"
    static TYPE_VC_MESSGAE = "message-vc"
    static TYPE_FORMVC_MESSGAER = "formvc-message"
    static TYPE_CALL_MESSAGE = "message-call"
    static TYPE_FORM_CALL = "formcall-message"
    static TYPE_AUDIO_MESSAGE = "audio-message"
    static TYPE_MESSAGE_LEAD = "request-lead"
    static TYPE_MESSAGE_CONTROLLO_LINEA = "message-controllo-linea"
    static TYPE_TICKET_FAULT = "ticket-fault"

    static DELIVERY_WEB = "web"; 

    constructor() {
        this.tokenAccess = BackendApi.getTokenAccess()                               
    }

    prepareSendMessage(type, userId, message, to, chatId, type_message, fonte = "", message_id = "", argomento = null) {        
        return {
            "date": parseInt(new Date().getTime() / 1000),
            "type": type,
            "typeMessage": type_message,
            "userId": userId,
            "tokenAccess": this.tokenAccess,
            "message": message,
            "from": userId,
            "to": to,
            "channelType": "chat",
            "messageId": message_id,
            "chatId": chatId,
            "delivery": "web",
            "fonte": fonte,
            "argomento": argomento,
        };
    }
    prepareSendMessageAudio(type,userId, message, to, chatId, type_message, fonte = "", message_id = "", argomento = null,attr = []) {        
        return {
            "date": parseInt(new Date().getTime() / 1000),
            "type": type,
            "typeMessage": type_message,
            "userId": userId,
            "tokenAccess": this.tokenAccess,
            "message": message,
            "from": userId,
            "to": to,
            "channelType": "chat",
            "messageId": message_id,
            "chatId": chatId,
            "delivery": "web",
            "fonte": fonte,
            "argomento": argomento,
            "attr": attr
        };
    }

    prepareSendMessageVC(type, userId, message, to, chatId, type_message, fonte = "", message_id = "", argomento = null,attr = []) {        
        return {
            "date": parseInt(new Date().getTime() / 1000),
            "type": type,
            "typeMessage": type_message,
            "userId": userId,
            "tokenAccess": this.tokenAccess,
            "message": message,
            "from": userId,
            "to": to,
            "channelType": "chat",
            "messageId": message_id,
            "chatId": chatId,
            "delivery": "web",
            "fonte": fonte,
            "argomento": argomento,
            "attr": attr
        };
    }

    prepareSendMessageTicketFault(type, userId, message, to, chatId, type_message, fonte = "", message_id = "", argomento = null,attr = []){
        return {
            "date": parseInt(new Date().getTime() / 1000),
            "type": type,
            "typeMessage": type_message,
            "userId": userId,
            "tokenAccess": this.tokenAccess,
            "message": message,
            "from": userId,
            "to": to,
            "channelType": "chat",
            "messageId": message_id,
            "chatId": chatId,
            "delivery": "web",
            "fonte": fonte,
            "argomento": argomento,
            "attr": attr
        }
    }

    prepareSendNotifyMessage(type, userId, message, to, chatId, listMessageID, type_message) {
        return {
            "date": parseInt(new Date().getTime() / 1000),
            "type": type,
            "typeMessage": type_message,
            "userId": userId,
            "tokenAccess": this.tokenAccess,
            "message": message,
            "from": userId,
            "to": to,
            "channelType": "chat",
            "messageId": listMessageID,
            "chatId": chatId,
            "delivery": "web"
        };
    }
}
